import {useDispatch, useSelector} from 'react-redux';
import React, {useCallback} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import PersonIcon from '@material-ui/icons/Person'
import makeStyles from '@material-ui/core/styles/makeStyles';
import {toggleModalAction} from 'module/Modal/action/ModalAction';
import {ModalKey} from 'module/Modal/type/ModalKey';
import HomeIcon from '@material-ui/icons/Home'
import {TopNavBarButtonComponent} from 'module/TopNavBar/component/TopNavBarButton/TopNavBarButtonComponent';
import {TopNavBarLeftButtonSection} from 'module/TopNavBar/component/TopNavBarLeftButtonSection';
import {TopNavBarButtonGroup} from 'module/TopNavBar/component/TopNavBarButton/TopNavBarButtonGroup';
import {selNotiShowButton} from 'module/Noti/selector/NotiSelector';
import {NotiButton} from 'module/Noti/component/NotiButton';
import {SwitchBackToDefaultUserButton} from 'module/TopNavBar/component/TopNavBarButton/SwitchBackToDefaultUserButton';
import Tooltip from '@material-ui/core/Tooltip';
import {selTopNavBarTitle} from 'module/TopNavBar/selector/TopNavBarSelector'
import {selCurrentUserIsAlternative, selCurrentUsernameLong} from 'module/SessionInfo/selector/SessionInfoSelector'

const useStyles = makeStyles(theme => ({
	root: {
		flexGrow: 1,
		minHeight: theme.spacing(5),
		maxHeight: theme.spacing(5),
	},
	toolbar: {
		minHeight: theme.spacing(5),
		maxHeight: theme.spacing(5),
	},
	title: {
		top: theme.spacing(0.5), // fix IE
		position: 'fixed',
		width: '100%',
	},
	spacer: {
		flexGrow: 10,
	},
	left: {
		flexGrow: 0,
		flexShrink: 1,
		wordBreak: 'break-word',
	},
	right: {
		whiteSpace: 'pre',
		flexGrow: 0,
		flexShrink: 1,
		zIndex: 1, // for background visible
		background: theme.palette.primary.main,
	},
}), {name: 'TopNavBar'});

export const TopNavBar = React.memo(() => {
	const classes = useStyles()
	const longUsername = useSelector(selCurrentUsernameLong)
	const isAlt = useSelector(selCurrentUserIsAlternative)
	const title = useSelector(selTopNavBarTitle)
	const showNotiButton = useSelector(selNotiShowButton)

	const dispatch = useDispatch();
	const onClickUserButton = useCallback(() => dispatch(toggleModalAction({modalKey: ModalKey.SessionInfo, open: true})), [dispatch]);

	let userButtonStyle;
	if (isAlt) {
		userButtonStyle = {color: '#d6cc3a'}
	}
	return (
		<AppBar position={'fixed'} color={'primary'} className={classes.root}>
			<Toolbar variant={'dense'} className={classes.toolbar}>
				<Typography variant="h6" align={'center'} className={classes.title}>
					<Tooltip title={title || ''} enterDelay={1200}>
						<span>{title}</span>
					</Tooltip>
				</Typography>
				<Typography component={'div'} align={'left'} className={classes.left}>
					<TopNavBarLeftButtonSection/>
				</Typography>
				<Typography component={'div'} align={'left'} className={classes.spacer}/>
				<Typography component={'div'} align={'right'} className={classes.right}>
					{showNotiButton &&
						<NotiButton/>
					}
					<TopNavBarButtonGroup>
						<TopNavBarButtonComponent href="home.jsp" target="_self">
							<HomeIcon fontSize={'small'}/>
						</TopNavBarButtonComponent>
						<TopNavBarButtonComponent style={userButtonStyle} onClick={onClickUserButton}>
							<PersonIcon fontSize={'small'}/>&nbsp;{longUsername}
						</TopNavBarButtonComponent>
					</TopNavBarButtonGroup>
					{isAlt &&
						<SwitchBackToDefaultUserButton/>
					}
				</Typography>
			</Toolbar>
		</AppBar>
	);
});